import { BaseLookupModel, PaginationFilterRequest } from "./core.model";
import { UserLookup } from "./user.model";

/** A club-owned leadership card: picture, name, title and bio.
 *  The profile belongs to the club, so userId stays null until a registered
 *  user is assigned to it. displayOrder sorts the strip ascending. */
export interface RunningClubCaptainProfile {
  id: number;
  runningClubId: number;
  userId?: number;
  imageUrl?: string;
  name?: string;
  title?: string;
  description?: string;
  displayOrder: number;
  createdAt?: string;
  runningClub?: BaseLookupModel;
  user?: UserLookup;
}

export interface UpsertRunningClubCaptainProfile {
  id?: number;
  runningClubId?: number;
  userId?: number;
  imageUrl?: string;
  name?: string;
  title?: string;
  description?: string;
  displayOrder?: number;
}

export class RunningClubCaptainProfilePaginationFilterRequest extends PaginationFilterRequest {
  runningClubId?: number;
  userId?: number;
}
